/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import pinia from '../stores'
import router from '../router'

// Types
import type { App } from 'vue'
import vuetify from '@/plugins/vuetify/vuetify.ts'
import { getI18n } from '@/plugins/i18n.ts'
import { VAutocomplete } from 'vuetify/components'
import precognitionPlugin from '@/plugins/precognition.ts'
import phoneInputPlugin from '@/plugins/phoneInput.ts'
import TrackDirective from '@/plugins/directives/highlight.ts'

export function registerPlugins (app: App) {
  precognitionPlugin()

  app
    .component('VAutocomplete', VAutocomplete)
    .use(vuetify)
    .use(router)
    .use(pinia)
    .use(getI18n())
    .use(phoneInputPlugin())
    .directive('track',TrackDirective)
}
